export default "__VITE_ASSET__gwP_H60s__"